import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import AvatarGroup from '@mui/material/AvatarGroup';
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';
import Bs4GenericField from './Bs4GenericField'
import Bs4MainDispatch from '../../Bs4MainDispatch';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Bs4ViewAvatar from '../../Bs4Components/Bs4ViewAvatar';

export default class Bs4Avatar extends Bs4GenericField {  

  ViewAvatarList = (props) => {    
    const formField = this;        

    const handleClick = (avatar) => props.onClick(avatar);

    return (
      <List>
        {props.avatars.map(avatar => {
          return (
            <ListItemButton key={avatar.rowId} onClick={() => handleClick(avatar)}>
              <ListItemAvatar>
                <Bs4ViewAvatar fileId={avatar.fileId} initials={avatar.initials} label={avatar.label} circleColor={avatar.circleColor}/>
              </ListItemAvatar>
            <ListItemText primary={avatar.label}/>
          </ListItemButton>
          )
        })}        
      </List>
    )
  }

  ViewComponentField = (props) => {
    const formField = this;
    this.refFocus = React.useRef();
    const [value, setValue] = React.useState(() => this.getValue());
    const avatars = React.useMemo(() => {
      if (!Array.isArray(value)) return [];      
      return value;
    }, [value])

    const handleClick = (avatar) => {
      // console.log('...Avatar...click...', avatar);
      Bs4MainDispatch.commandParser('Bs4FormFieldValue', {currFormId: this.props.field.formId, rowId: avatar.rowId}, this.bs4KartotekaId);
    }  

    React.useEffect(() => {
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue());
      })    
    }, []);    
    
    return (
      <FormControl fullWidth >
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Tooltip
          title={<formField.ViewAvatarList avatars={avatars} onClick={handleClick}/>}
          placement="bottom-start"
          slotProps={{
            tooltip: {
              sx: {
                backgroundColor: 'background.paper',
                color: '#000000',
                maxHeight: '50vh',                 
                overflow: 'auto', 
              }
            }
          }}
        >
          <AvatarGroup max={5}>
            {avatars.map(avatar => {
              return (
                <Bs4ViewAvatar 
                  key={avatar.rowId} 
                  fileId={avatar.fileId} 
                  initials={avatar.initials} 
                  label={avatar.label} 
                  circleColor={avatar.circleColor}
                  onClick={() => handleClick(avatar)}
                />
              )
            })}
          </AvatarGroup>
        </Tooltip>
      </FormControl>
    );
  }
}